import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateAccountStatusSlice = getBulkActionSlice(
    'updateAccountStatusResult',
);

export const selectUpdateAccountStatusShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.updateAccountStatusResult.shown;

export const selectUpdateAccountStatusBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.updateAccountStatusResult.uuid;

export const selectUpdateAccountStatusTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.updateAccountStatusResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = updateAccountStatusSlice.actions;
